// extracted by mini-css-extract-plugin
export var card = "home-module--card--f-c4b";